const doc = [({"en":({"js":({"admin":({"comments":({"index":({"the_comment_was_added":"The comment was added"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;